export const getIn = (obj, path) => path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);

/** Immutable set by dot path. */
export const setIn = (obj, path, value) => {
  const [head, ...rest] = path.split('.');
  const base = obj && typeof obj === 'object' ? obj : {};
  return { ...base, [head]: rest.length ? setIn(base[head], rest.join('.'), value) : value };
};
